export default function sendAppointment(timeNumber, sentFrom) {
  var date;
  var currentTime = new Date();
  if (document.getElementsByClassName("hiddenInput")[0].value === "") {
    date = document.getElementsByClassName("hiddenInput")[0].value =
      currentTime.getMonth() +
      1 +
      "/" +
      currentTime.getDate() +
      "/" +
      currentTime.getFullYear();
  } else {
    date = document.getElementsByClassName("hiddenInput")[0].value;
  }
  var phone = document.getElementsByClassName("landingPhoneInput")[0].value;
  var time = timeNumber === 1 ? "11:00 am - 2:00 pm" : "2:00 pm - 7:00 pm";

  const url =
    "https://us-central1-phonefix-pro.cloudfunctions.net/appointmentSending";
  const GEN_KEY = "ZrkY0kzbfDCEUS6ZkcTzz7ff4UnXgqGd";
  const params = {
    date: date,
    phone: phone,
    time: time,
    sentFrom: sentFrom,
    gen_key: GEN_KEY,
  };

  fetch(`${url}?${new URLSearchParams(params).toString()}`)
    .then(resp => resp.json())
    .then(data => {
      console.log(data)
      /*alert("Your request was sent successful!")
      window.location.reload()*/
    })
    .catch(error => {
      console.log(error)
      alert(
        "There was an Error Sending your request. Please Submit the form Again"
      )
      // location.reload();
    })
}
